import { Link } from "react-router-dom";

function ArticleTile(props) {
  const imagePath = require(`../assets/${props?.imageName}`);
  return (
    <div className="article-container" style={{ marginBottom: "15px" }}>
      <div className="image-container">
        <Link to={props?.path}>
          <img
            src={imagePath}
            alt={props?.imageName}
            style={{ maxWidth: "100%", borderRadius: "4px" }}
          ></img>
        </Link>
      </div>

      <div className="article-title" style={{ width: "100%" }}>
        <Link
          to={props?.path}
          style={{ float: "left", textAlign: "left", color: "#003366" }}
        >
          {props.title}
        </Link>
      </div>
    </div>
  );
}

export default ArticleTile;
